import { useMemo } from "react";
import { useFlows, FlowsSubView } from "../../../stores/flowsStore";

export interface UseFlowsTabReturn {
  currentSubView: FlowsSubView;
}

export function useFlowsTab(): UseFlowsTabReturn {
  const { currentSubView } = useFlows();

  return useMemo(() => ({
    currentSubView,
  }), [currentSubView]);
}
